import Vue from 'vue'
import App from './App.vue'
import ElementUI, { Message } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import router from './router'
import dayjs from 'dayjs'
import './element-variables.scss'
import '@/assets/dsa/styles.css'
import 'normalize.css'
import locale from 'element-ui/lib/locale/lang/en'
import DsaLoading from '@/components/DsaLoading.vue'

Vue.config.productionTip = false
Vue.prototype.$dayjs = dayjs
Vue.use(ElementUI, { locale })
Vue.component('DsaLoading', DsaLoading)

// Keep Element toasts below the 60px DSA portal header (default offset is 20).
const MESSAGE_TOP_OFFSET = 72
function dsaMessage(options) {
  if (typeof options === 'string') {
    options = { message: options }
  }
  if (options.offset == null) {
    options.offset = MESSAGE_TOP_OFFSET
  }
  return Message(options)
}
;['success', 'warning', 'info', 'error'].forEach((type) => {
  dsaMessage[type] = (options) => {
    if (typeof options === 'string') {
      options = { message: options }
    }
    options.type = type
    return dsaMessage(options)
  }
})
dsaMessage.close = Message.close
dsaMessage.closeAll = Message.closeAll
Vue.prototype.$message = dsaMessage

new Vue({
    router,
    render: h => h(App),
}).$mount('#app')
